/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { AppError } from './AppError';

export class UnauthorisedError extends AppError {
    constructor() {
        super('Not Authorised', 'saml token or access token expired');
    }
}
